export default {
	lvyoucuxiao: '旅遊促銷高達50%折扣',
	guanzhuwomen: '關注我們50%折扣',
	miyuetaocan: '蜜月套餐',
	lvyoucuxiaohuodong: '旅行促銷活動',
	dujiatiantang: '度假天堂',
	zhongguo: '中國',
	yingguo: '紐西蘭',
	aodaliya: '澳大利亞',
	taiguo: '泰國',
	xianggang: '香港',
	foluolidazhou: '奧克蘭',
	xini: '悉尼',
	mangu: '曼谷',
	shanshuizhimei: '山水之美',
	xinxilandemeijing: '新西蘭的美景',
	xinigejuyuan: '悉尼歌劇院',
	zaimanguyaozuodeshiqing: '在曼谷要做的事情',
	lvyoucu: '旅行促銷',
	daizhewomende: '帶著我們的蜜月套餐逃到浪漫的天堂。 在您的私人別墅放鬆身心，享受水療護理，欣賞迷人的海景。',
	tongguodaoyou: '通過導遊和烹飪課程探索當地文化。 讓我們處理好細節，從此開始你的幸福生活。',
	lijiyuding: '立即預訂，度過難忘的蜜月。',
	jingdu: '京都4d3n班機 + 飯店套餐2件',
	pujidao: '普吉島淡季4天 班機+飯店套餐',
	xianggangfei: '香港飛沖繩機票',
	xinidaolundun: '悉尼飛倫敦機票',
	malaixiyarelangdao: '馬來西亞熱浪島+沙灘漫步+夜間追尋藍淚',
	yidianshan: '伊甸山',
	aokelan: '奧克蘭',
	pingfen: '評分',
	yidianshanjianjie: "奧克蘭四周被海洋和火山環抱，地標之一的伊甸山便是座死火山。伊甸山至今仍保存奧克蘭原始的毛利堡壘，也是俯視奧克蘭的好地方。",
	dibiaotiankongta: '地標天空塔',
	dibiaotiankongtajianjie: "塔頂360°的瞭望台可將市區延伸至東西兩岸全景盡收眼底。在晴天可以看到方圓82公里之遠，這裏是欣賞奧克蘭夜景的最佳地點。",
	habirencun: '哈比人村',
	habirencunjianjie: "魔戒哈比人那個與世無爭的夏爾村莊，應該是好多人嚮往的世界！相比新西蘭其他了無人煙的大自然景點，最熱鬧的應該就是這裡了，有些區域甚至要用擁擠來形容，可見這部電影的影響力有多大！",
	lanquan: '藍泉',
	lanquanjianjie: "參觀完哈比人村，可以安排兩個小時到附近的秘景Blue Spring，大部分人去完都會用夢幻來形容。泉水源自於瑪瑪庫高原，極致的純淨，需經由100年的層層過濾才到達地表。聽聞新西蘭70%的瓶裝水都來自這裡哦。",
	jiduchengzhiwuyuan: '基督城植物園',
	jiduchengzhiwuyuanjianjie: "基督城植物園為基督城市民平日休閒散心的公園。園區內有許多的主題小花園，香草園、玫瑰園、溫室花園等，一年四季開滿了美麗的花朵，是新西蘭最棒的植物園之一。",
	remenjingxuan: '熱門旅遊精選',
	remenjingxuanbiaoti2: '熱門旅遊精選',
	remenjingxuanmiaoshu2: '熱門旅遊精選，品質之選，帶您探索世界精彩，享受完美假期。',
	remenjingxuanlianjiemiaoshu2: '為您精選最受歡迎的旅遊目的地和套餐，無論您是想放鬆身心、體驗文化還是享受美食，都能在這裡找到心儀的選擇',
	remenjingxuanlianjie2: '立即預訂，開啟您的美好旅程！',
	remenjingxuanbiaoti3: '限時特惠蜜月套餐',
	remenjingxuanmiaoshu3: '每月套餐，專屬浪漫，甜蜜時光，見證愛情，開啟幸福旅程。',
	remenjingxuanlianjiemiaoshu3: '抓住機會，享受我們為您量身定制的限時特惠旅遊套餐。 無論您喜歡海灘度假、城市探險還是文化體驗，我們都有適合您的選擇',
	remenjingxuanlianjie3: '立即預訂，開啟您的夢想之旅，不要錯過這些難得的優惠！',
	remenjingxuanbiaoti4: '探索世界，盡享優惠',
	remenjingxuanmiaoshu4: '探索世界，即刻出發，盡享優惠，開啟您的精彩旅程，不容錯過',
	remenjingxuanlianjiemiaoshu4: '無論您是尋求刺激的探險家，還是渴望放鬆的度假者，我們都能滿足您的需求',
	remenjingxuanlianjie4: '現在就預定，享受超值優惠',
	remenjingxuanbiaoti5: '度假天堂，專屬定制，打造完美假期',
	remenjingxuanmiaoshu5: '度假天堂，放鬆身心，享受陽光沙灘，讓煩惱煙消雲散，盡情擁抱美好',
	remenjingxuanlianjiemiaoshu5: '帶著我們的蜜月套餐逃到浪漫的天堂，在您的私人別墅放鬆身心，享受水療護理，欣賞迷人的海景',
	remenjingxuanlianjie5: '現在就預定，從此開始你的幸福生活！',
	xinjiapomangu: '新加坡飛曼谷機票',
	xinjiapoxianggang: '新加坡飛香港機票',
	xinjiapojilongpo: '新加坡飛吉隆玻機票',
	xinjiapoguangzhou: '新加坡飛廣州機票',
	xinjiapoxini: '新加坡飛雪梨機票',
	xiangganglundun: '香港飛倫敦機票',
	xianggangxini: '香港飛雪梨機票',
	xinjiapobalidao: '新加坡飛巴厘島機票',
	xianggangyadian: '香港飛雅典機票',
	xianggangkailuo: '香港飛開羅機票',
	niuyuebeihaidao: '紐約飛北海道機票',
	xianggangmilan: '香港飛米蘭機票',
	xianggangbali: '香港飛巴黎機票',
	niuyueshengbaoluo: '紐約飛聖保羅機票',
	niuyueyatelanda: '紐約飛亞特蘭大機票',
	xianbenna: '仙本那',
	malaixiya: '馬來西亞',
	sulishi: '蘇黎世',
	ruishi: '瑞士',
	riyuetan: '日月潭',
	taiwan: '中國·臺灣',
	xiyatu: '西雅圖',
	huashengdun: '美國·華府',
	mudidibiaoti1: '熱門景點',
	mudidimiaoshu1: '仙本那的美景',
	mudidibiaoti2: '熱門景點',
	mudidimiaoshu2: '蘇黎世的美景',
	mudidibiaoti3: '熱門景點',
	mudidimiaoshu3: '臺灣的美景',
	mudidibiaoti4: '熱門景點',
	mudidimiaoshu4: '西雅圖的美景',
	mudidijingdianbiaoti1: '卡帕萊島',
	mudidijingdianmiaoshu1: '卡帕萊島，一個漂浮在碧海之上的夢幻天堂，被清澈見底的海水和五彩斑斕的珊瑚礁環繞宛如一顆遺落在海上的璀璨寶石，寧靜而又充滿生機。',
	mudidijingdianbiaoti2: '敦沙卡蘭海洋公園',
	mudidijingdianmiaoshu2: '敦沙卡蘭海洋公園，不僅可以潜水、浮潜，還可以徒步登山，欣賞壯麗的全景，體驗當地的文化，讓您的旅程充滿探險和樂趣，收穫難忘的回憶。',
	mudidijingdianbiaoti3: '汀巴汀巴島',
	mudidijingdianmiaoshu3: '汀巴汀巴島，是一個未被過度開發的寧靜小島，以其原始的自然風光和豐富的海洋生物而著稱。這裡擁有清澈的海水、美麗的珊瑚礁和多樣的海洋生物，是潜水、浮潜和放鬆身心的絕佳去處。 島上環境寧靜，適合尋求遠離喧囂、親近自然的旅行者。',
	mudidijingdianbiaoti4: '西巴丹島',
	mudidijingdianmiaoshu4: '在西巴丹島潜水，您將有機會與成群的海龜、鯊魚和梭魚共舞，感受大自然的壯麗和神奇這是一次難忘的水下探險，讓您終生難忘。',
	mudidijingdianbiaoti5: '珍珠島',
	mudidijingdianmiaoshu5: '在珍珠島，您可以盡情享受陽光、沙灘、海水，體驗各種水上活動，探索美麗的海底世界感受大自然的魅力。您也可以在沙灘上漫步，欣賞日出日落的壯麗景色，讓心靈得到徹底的放鬆。',
	mudidijingdianbiaoti6: '軍艦島',
	mudidijingdianmiaoshu6: '軍艦島，一個充滿活力和樂趣的海島，以其迷人的海灘、清澈的海水和豐富的海洋生物而聞名。在這裡，您可以盡情享受浮潜的樂趣，與各種海洋生物親密接觸，感受海洋的魅力。',
	mudidijingdianbiaoti7: '蘇黎世大教堂',
	mudidijingdianmiaoshu7: '蘇黎世大教堂，以其獨特的雙塔和雄偉的建築風格吸引著無數遊客。您可以在這裡感受歷史的厚重，欣賞精美的藝術品，登上塔樓俯瞰蘇黎世美景。',
	mudidijingdianbiaoti8: '瑞士國立博物館',
	mudidijingdianmiaoshu8: '瑞士國立博物館，是一個充滿知識和趣味的博物館。您可以在這裡探索瑞士的歷史和文化，欣賞精美的藝術品，感受瑞士的獨特魅力。',
	mudidijingdianbiaoti9: '蘇黎世美術館',
	mudidijingdianmiaoshu9: '蘇黎世美術館（Kunsthaus Zürich），是瑞士最重要的美術館之一，收藏了從中世紀到現代的各種藝術作品。館內藏品豐富多樣，包括繪畫、雕塑、版畫、攝影等，涵蓋了瑞士和國際藝術家的作品。您可以在這裡欣賞到印象派、表現主義、超現實主義等不同流派的藝術作品。',
	mudidijingdianbiaoti10: '聖母教堂',
	mudidijingdianmiaoshu10: '聖母教堂，是一座歷史悠久的教堂，其歷史可以追溯到9世紀。教堂不僅是宗教場所也是重要的文化遺產。 除了夏加爾的彩色玻璃窗，教堂內還有其他值得欣賞的藝術品如管風琴和壁畫。教堂的尖塔也是蘇黎世的標誌性景觀之一。',
	mudidijingdianbiaoti11: '班霍夫大街',
	mudidijingdianmiaoshu11: '班霍夫大街，不僅是購物的場所，也是蘇黎世的中心。這條街道連接著蘇黎世火車站和蘇黎世湖，是遊客必經之地。您可以在這裡欣賞到蘇黎世的都市風光，感受這座城市的繁華和活力。此外，街道兩旁還有許多咖啡館和餐廳，供您休息和放鬆。',
	mudidijingdianbiaoti12: '林登霍夫山',
	mudidijingdianmiaoshu12: '林登霍夫山，是蘇黎世的標誌性景點之一。在這裡，您不僅可以欣賞到美麗的都市風光還可以感受到蘇黎世的歷史氛圍。山頂的公園是當地居民休閒放鬆的好去處，您可以在這裡散步、休息，享受寧靜的時光。此外，這裡也是拍攝蘇黎世全景的絕佳地點。',
	mudidijingdianbiaoti13: '日月潭',
	mudidijingdianmiaoshu13: '日月潭（Sun Moon Lake），是臺灣最著名的景點之一，也是臺灣最大的天然湖泊。 湖面被拉魯島分隔，北側形如太陽，南側形如月亮，囙此得名。日月潭周圍群山環繞，景色優美，湖光山色相映成趣。這裡不僅有美麗的自然風光，還有豐富的高山族文化，是體驗臺灣文化和自然風光的理想之地。',
	mudidijingdianbiaoti14: '九族文化村',
	mudidijingdianmiaoshu14: '九族文化村，是臺灣一個獨具特色的主題樂園，以臺灣九大原住民族的文化為主題，展示了各族的生活方式、傳統藝術和建築特色。您可以在這裡參觀高山族的傳統家屋、欣賞精彩的歌舞表演、體驗高山族的手工藝，還能乘坐刺激的遊樂設施，是一個集文化、娛樂、教育於一體的綜合性樂園。',
	mudidijingdianbiaoti15: '日月潭纜車',
	mudidijingdianmiaoshu15: '日月潭纜車，採用最新的纜車科技，乘坐舒適安全。纜車分為普通車廂和水晶車廂，水晶車廂的底部是透明的，可以讓您更清晰地欣賞脚下的美景，體驗更加刺激。纜車全程約10分鐘您可以盡情享受高空欣賞美景的樂趣，是日月潭旅遊不可錯過的體驗。',
	mudidijingdianbiaoti16: '阿里山國家風景區',
	mudidijingdianmiaoshu16: '阿里山，不僅是自然景觀的代表，也是臺灣的文化象徵。這裡有豐富的動植物資源，是生態旅遊的理想之地。您可以漫步於森林步道，呼吸新鮮空氣，欣賞美麗的自然風光。此外，阿里山的日出和雲海更是吸引了無數遊客前來觀賞，是體驗臺灣高山之美的必遊之地。',
	mudidijingdianbiaoti17: '清境農場',
	mudidijingdianmiaoshu17: '清境農場，是臺灣著名的高山農場，以其優美的自然風光、歐洲風格的建築和可愛的綿羊秀而聞名，是體驗高山農場生活的理想之地。',
	mudidijingdianbiaoti18: '彩虹眷村',
	mudidijingdianmiaoshu18: '彩虹眷村，以其獨特的彩繪藝術而聞名，每一面牆壁都充滿了不同的色彩和圖案，仿佛置身於一個童話世界。您可以在這裡漫步，欣賞各種有趣的彩繪，感受藝術的魅力。此外，彩虹眷村的故事也感動了許多人，讓大家更加珍惜身邊的美好事物。',
	mudidijingdianbiaoti19: '太空針塔',
	mudidijingdianmiaoshu19: '太空針塔，是美國西雅圖最著名的地標之一，以其獨特的造型和頂部的觀景台而聞名遊客可以乘坐高速電梯到達觀景台，欣賞到360度無死角的西雅圖都市全景，包括普吉特海灣、奧林匹克山脈和雷尼爾山等壯麗景色。太空針塔不僅是西雅圖的象徵，也是一個重要的旅遊景點。',
	mudidijingdianbiaoti20: '派克市場',
	mudidijingdianmiaoshu20: '派克市場，位於西雅圖市中心，是一個充滿活力和人情味的農貿市場。這裡有各種各樣的攤位，從新鮮的海鮮到當地的農產品，應有盡有。您可以在這裡品嘗到美味的當地美食，欣賞到街頭藝人的表演，還可以與當地居民互動，感受西雅圖的獨特魅力。派克市場是一個充滿驚喜和樂趣的地方。',
	mudidijingdianbiaoti21: '奇胡利玻璃藝術園',
	mudidijingdianmiaoshu21: '奇胡利玻璃藝術園，以其獨特的玻璃藝術品和展覽管道而聞名。您可以在這裡漫步，欣賞各種精美的玻璃雕塑和裝置，感受玻璃藝術的獨特魅力。藝術園內還設有玻璃溫室，展示了奇胡利的大型玻璃裝置，讓您仿佛置身於一個奇幻的玻璃世界。奇胡利玻璃藝術園是一個充滿藝術氣息和視覺享受的地方。',
	mudidijingdianbiaoti22: '華盛頓大學',
	mudidijingdianmiaoshu22: '華盛頓大學，是美國西海岸最著名的公立研究型大學之一，位於西雅圖市中心。這所大學以其美麗的校園、卓越的學術水準和强大的研究實力而聞名，擁有世界一流的圖書館、實驗室和研究中心。華盛頓大學不僅是學術研究的殿堂，也是一個充滿活力和多元文化的地方。',
	mudidijingdianbiaoti23: '飛行博物館',
	mudidijingdianmiaoshu23: '飛行博物館，不僅有各種各樣的飛機，還有許多互動展品和模擬器，讓您身臨其境地體驗飛行。您可以在這裡參觀波音公司最初的工廠，瞭解波音公司的發展歷史，還可以體驗到飛行模擬器的樂趣。飛行博物館是一個適合各個年齡段的遊客參觀的景點，無論是航空愛好者還是普通遊客，都能在這裡找到樂趣。',
	mudidijingdianbiaoti24: '西雅圖水族館',
	mudidijingdianmiaoshu24: '西雅圖水族館，位於西雅圖海濱，是一個展示太平洋西北部海洋生物的著名水族館。這裡有各種各樣的海洋生物，包括海獺、海豹、章魚、水母和各種魚類，您可以在這裡近距離觀察這些可愛的生物，並瞭解到它們的習性和棲息地。西雅圖水族館不僅是一個觀賞海洋生物的地方，也是一個學習海洋知識和保護海洋環境的場所。',
};
